module['exports'] = [
  'Abbondanza',
  'Acilia',
  'Ada',
  'Adalberta',
  'Adalgisa',
  'Addolorata',
  'Adelaide',
  'Adelasia',
  'Adele',
  'Adelina',
  'Adina',
  'Adria',
  'Adriana',
  'Agape',
  'Agata',
  'Agnese',
  'Agostina',
  'Aida',
  'Alba',
  'Alberta',
  'Albina',
  'Alcina',
  'Alda',
  'Alessandra',
  'Alessia',
  'Alfonsa',
  'Alfreda',
  'Alice',
  'Alida',
  'Alina',
  'Allegra',
  'Alma',
  'Altea',
  'Amalia',
  'Amanda',
  'Amata',
  'Ambra',
  'Amelia',
  'Amina',
  'Anastasia',
  'Anatolia',
  'Ancilla',
  'Andromeda',
  'Angela',
  'Angelica',
  'Anita',
  'Anna',
  'Annabella',
  'Annagrazia',
  'Annamaria',
  'Annunziata',
  'Antea',
  'Antigone',
  'Antonella',
  'Antonia',
  'Apollina',
  'Apollonia',
  'Appia',
  'Arabella',
  'Argelia',
  'Arianna',
  'Armida',
  'Artemisa',
  'Asella',
  'Asia',
  'Assunta',
  'Astrid',
  'Atanasia',
  'Aurelia',
  'Aurora',
  'Ausilia',
  'Ausiliatrice',
  'Ave',
  'Aza',
  'Azelia',
  'Azzurra',
  'Babila',
  'Bambina',
  'Barbara',
  'Bartolomea',
  'Basilia',
  'Bassilla',
  'Batilda',
  'Beata',
  'Beatrice',
  'Belina',
  'Benedetta',
  'Beniamina',
  'Benigna',
  'Benvenuta',
  'Berenice',
  'Bernadetta',
  'Betta',
  'Bianca',
  'Bibiana',
  'Bice',
  'Brigida',
  'Brigitta',
  'Bruna',
  'Brunilde',
  'Calogera',
  'Calpurnia',
  'Camelia',
  'Camilla',
  'Candida',
  'Capitolina',
  'Carina',
  'Carla',
  'Carlotta',
  'Carmela',
  'Carmen',
  'Carola',
  'Carolina',
  'Casilda',
  'Casimira',
  'Cassandra',
  'Cassiopea',
  'Catena',
  'Caterina',
  'Cecilia',
  'Celeste',
  'Celinia',
  'Chiara',
  'Cinzia',
  'Cirilla',
  'Clara',
  'Claudia',
  'Clelia',
  'Clemenzia',
  'Cleo',
  'Cleofe',
  'Cleopatra',
  'Cloe',
  'Clorinda',
  'Cointa',
  'Colomba',
  'Concetta',
  'Consolata',
  'Cora',
  'Cordelia',
  'Corinna',
  'Cornelia',
  'Cosima',
  'Costanza',
  'Crescenzia',
  'Cristiana',
  'Cristina',
  'Crocefissa',
  'Cronida',
  'Cunegonda',
  'Cuzia',
  'Dafne',
  'Dalida',
  'Dalila',
  'Damiana',
  'Daniela',
  'Daria',
  'Deanna',
  'Debora',
  'Degna',
  'Delfina',
  'Delia',
  'Delinda',
  'Delizia',
  'Demetria',
  'Deodata',
  'Desdemona',
  'Desiderata',
  'Devota',
  'Diamante',
  'Diana',
  'Dianora',
  'Diletta',
  'Dina',
  'Diodata',
  'Dionisia',
  'Doda',
  'Dolores',
  'Domenica',
  'Donata',
  'Donatella',
  'Donna',
  'Dora',
  'Dorotea',
  'Druina',
  'Dulina',
  'Ebe',
  'Edda',
  'Edelberga',
  'Editta',
  'Edvige',
  'Egizia',
  'Egle',
  'Elaide',
  'Elda',
  'Elena',
  'Eleonora',
  'Elettra',
  'Eliana',
  'Elide',
  'Elimena',
  'Elisa',
  'Elisabetta',
  'Elisea',
  'Ella',
  'Eloisa',
  'Elsa',
  'Elvia',
  'Elvira',
  'Emanuela',
  'Emilia',
  'Emiliana',
  'Emma',
  'Enimia',
  'Enrica',
  'Eracla',
  'Ermelinda',
  'Ermenegarda',
  'Ermenegilda',
  'Erminia',
  'Ernesta',
  'Ersilia',
  'Esmeralda',
  'Estella',
  'Ester',
  'Esterina',
  'Eufemia',
  'Eufrasia',
  'Eugenia',
  'Eulalia',
  'Euridice',
  'Eusebia',
  'Eutalia',
  'Eva',
  'Evangelina',
  'Evelina',
  'Fabiana',
  'Fabiola',
  'Fatima',
  'Fausta',
  'Federica',
  'Fedora',
  'Felicia',
  'Felicita',
  'Fernanda',
  'Fiammetta',
  'Filippa',
  'Filomena',
  'Fiordaliso',
  'Fiore',
  'Fiorella',
  'Fiorenza',
  'Flaminia',
  'Flavia',
  'Flaviana',
  'Flora',
  'Floriana',
  'Floridia',
  'Florina',
  'Foca',
  'Fortunata',
  'Fosca',
  'Franca',
  'Francesca',
  'Fulvia',
  'Gabriella',
  'Gaia',
  'Galatea',
  'Gaudenzia',
  'Gelsomina',
  'Geltrude',
  'Gemma',
  'Generosa',
  'Genesia',
  'Genoveffa',
  'Germana',
  'Gertrude',
  'Ghita',
  'Giacinta',
  'Giada',
  'Gigliola',
  'Gilda',
  'Giliola',
  'Ginevra',
  'Gioacchina',
  'Gioconda',
  'Gioia',
  'Giorgia',
  'Giovanna',
  'Gisella',
  'Giuditta',
  'Giulia',
  'Giuliana',
  'Giulitta',
  'Giuseppa',
  'Giuseppina',
  'Giusta',
  'Glenda',
  'Gloria',
  'Godeberta',
  'Godiva',
  'Grazia',
  'Graziana',
  'Graziella',
  'Greta',
  'Griselda',
  'Guenda',
  'Guendalina',
  'Gundelinda',
  'Ianira',
  'Ida',
  'Idea',
  'Iginia',
  'Ilaria',
  'Ilda',
  'Ildegarda',
  'Ildegonda',
  'Ileana',
  'Ilenia',
  'Ilia',
  'Ilva',
  'Imelda',
  'Immacolata',
  'Incoronata',
  'Ines',
  'Innocenza',
  'Iolanda',
  'Iole',
  'Iona',
  'Ione',
  'Ionne',
  'Irene',
  'Iride',
  'Iris',
  'Irma',
  'Irmina',
  'Isa',
  'Isabella',
  'Iside',
  'Isidora',
  'Isotta',
  'Italia',
  'Ivetta',
  'Lara',
  'Laura',
  'Lavinia',
  'Lea',
  'Leda',
  'Lelia',
  'Lena',
  'Leonia',
  'Leonilda',
  'Leontina',
  'Letizia',
  'Lia',
  'Liana',
  'Liberata',
  'Liboria',
  'Licia',
  'Lidania',
  'Lidia',
  'Liliana',
  'Linda',
  'Lisa',
  'Livia',
  'Liviana',
  'Lodovica',
  'Loredana',
  'Lorella',
  'Lorena',
  'Lorenza',
  'Loretta',
  'Loriana',
  'Luana',
  'Luce',
  'Lucia',
  'Luciana',
  'Lucilla',
  'Lucrezia',
  'Ludovica',
  'Luigia',
  'Luisa',
  'Luminosa',
  'Luna',
  'Macaria',
  'Maddalena',
  'Mafalda',
  'Magda',
  'Maida',
  'Manuela',
  'Mara',
  'Marana',
  'Marcella',
  'Mareta',
  'Margherita',
  'Maria',
  'Marianna',
  'Marica',
  'Mariella',
  'Marilena',
  'Marina',
  'Marinella',
  'Marinetta',
  'Marisa',
  'Marita',
  'Marta',
  'Martina',
  'Maruta',
  'Marzia',
  'Massima',
  'Matilde',
  'Maura',
  'Melania',
  'Melissa',
  'Melitina',
  'Menodora',
  'Mercede',
  'Messalina',
  'Mia',
  'Michela',
  'Milena',
  'Mimma',
  'Mina',
  'Minerva',
  'Minervina',
  'Miranda',
  'Mirella',
  'Miriam',
  'Mirta',
  'Moira',
  'Monica',
  'Morena',
  'Morgana',
  'Nadia',
  'Natalia',
  'Natalina',
  'Neiva',
  'Nerea',
  'Nicla',
  'Nicoletta',
  'Nilde',
  'Nina',
  'Ninfa',
  'Nives',
  'Noemi',
  'Norina',
  'Norma',
  'Novella',
  'Nuccia',
  'Nunziata',
  'Odetta',
  'Odilia',
  'Ofelia',
  'Olga',
  'Olimpia',
  'Olinda',
  'Olivia',
  'Oliviera',
  'Ombretta',
  'Ondina',
  'Onesta',
  'Onorata',
  'Onorina',
  'Orchidea',
  'Oriana',
  'Orietta',
  'Ornella',
  'Orsola',
  'Orsolina',
  'Ortensia',
  'Osanna',
  'Otilia',
  'Ottilia',
  'Palladia',
  'Palmazio',
  'Palmira',
  'Pamela',
  'Paola',
  'Patrizia',
  'Pelagia',
  'Penelope',
  'Perla',
  'Petronilla',
  'Pia',
  'Piera',
  'Placida',
  'Polissena',
  'Porzia',
  'Prisca',
  'Priscilla',
  'Proserpina',
  'Prospera',
  'Prudenzia',
  'Quartilla',
  'Quieta',
  'Quiteria',
  'Rachele',
  'Raffaella',
  'Rainelda',
  'Rebecca',
  'Regina',
  'Renata',
  'Riccarda',
  'Rina',
  'Rita',
  'Roberta',
  'Romana',
  'Romilda',
  'Romina',
  'Romola',
  'Rosa',
  'Rosalia',
  'Rosalinda',
  'Rosamunda',
  'Rosanna',
  'Rosita',
  'Rosmunda',
  'Rossana',
  'Rossella',
  'Rufina',
  'Saba',
  'Sabina',
  'Sabrina',
  'Samanta',
  'Samona',
  'Sandra',
  'Santina',
  'Sara',
  'Savina',
  'Scolastica',
  'Sebastiana',
  'Seconda',
  'Secondina',
  'Sefora',
  'Selene',
  'Selvaggia',
  'Semiramide',
  'Serafina',
  'Serena',
  'Severa',
  'Sibilla',
  'Sidonia',
  'Silvana',
  'Silvia',
  'Simona',
  'Simonetta',
  'Siria',
  'Smeralda',
  'Soave',
  'Sofia',
  'Sofronia',
  'Solange',
  'Sonia',
  'Speranza',
  'Stefania',
  'Stella',
  'Susanna',
  'Sveva',
  'Tabita',
  'Tamara',
  'Tarquinia',
  'Tarsilla',
  'Taziana',
  'Tea',
  'Tecla',
  'Telica',
  'Teodata',
  'Teodolinda',
  'Teodora',
  'Teresa',
  'Teudosia',
  'Tina',
  'Tiziana',
  'Tosca',
  'Trasea',
  'Tullia',
  'Ugolina',
  'Ulfa',
  'Uliva',
  'Unna',
  'Vala',
  'Valentina',
  'Valeria',
  'Valeriana',
  'Vanda',
  'Vanessa',
  'Vanna',
  'Venera',
  'Veneranda',
  'Venere',
  'Venusta',
  'Vera',
  'Verdiana',
  'Verena',
  'Veriana',
  'Veridiana',
  'Veronica',
  'Viliana',
  'Vilma',
  'Vincenza',
  'Viola',
  'Violante',
  'Virginia',
  'Vissia',
  'Vittoria',
  'Viviana',
  'Wanda',
  'Zabina',
  'Zaira',
  'Zama',
  'Zanita',
  'Zarina',
  'Zelinda',
  'Zenobia',
  'Zita',
  'Zoe',
  'Zosima'
];
